/**
 * The words of travel through a door (ADR-122 decisions 2.8 and 2.9, P1.4-T141), every one a draft for the author: the
 * message line for each reason `doorRefused` names, and the prompt of a door entered with the interact key.
 */
export const DOOR = {
  refused: {
    combat: "Sorry, you can't enter while in combat.",
    duel: "You can't go through a door during a duel.",
    held: "You can't go through a door right now.",
    full: "It's full in there. Try again soon.",
    closed: "That way is closed.",
    busy: "The door needs a moment.",
  },
  enter: "Enter {name}",
  press: "Press {key} to enter {name}",
  pressUnnamed: "Press {key} to enter",
  enterUnnamed: "Enter",
} as const;
